import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }

import { computed, ref } from 'vue';
import { useUserStore } from '@/stores/user'
import { upadateProfileImage } from '@/api/profile';
import StatusPopup from '@/components/common/statusPopup.vue';
import axios from 'axios';
import { baseURL } from '@/utils/request';
import { useI18n } from 'vue-i18n';
import LoadingScreen from '@/components/common/loadingScreen.vue';
import AvatarViewOne from '@/themes/themeOne/profile/avatarView.vue';
import AvatarViewTwo from '@/themes/themeTwo/profile/avatarView.vue';
import AvatarViewThree from '@/themes/themeThree/profile/avatarView.vue';
import { AvatarData } from './supportScript';
import { useThemeStore } from '@/stores/theme';

export default /*@__PURE__*/_defineComponent({
  __name: 'avatarView',
  setup(__props) {

const themeStore = useThemeStore()
const { t } = useI18n();
const statusRef = ref()
const toastContent = ref('')
const isSuccess = ref(false)
const loadingRef = ref()
const userStore = useUserStore()
const id = computed(() => userStore.id)
const avatarImg = computed(() => userStore.headimg)

const dataSet = computed<AvatarData>(() => ({
    avatarImg: avatarImg.value
}))

const afterRead = async (file: any) => {
    loadingRef.value.open()
    const formData = new FormData();
    formData.append("file", file.file);
    const token = localStorage.getItem('token')
    try {
        const response = await axios.post(`${baseURL}/app/common/uploadImage`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'authorization': `Bearer ${token}`,
                'clientid': '428a8310cd442757ae699df5d894f051'
            }
        });
        let data = response.data.data
        loadingRef.value.close()
        if (data.url) {
            updateProfile(data)
        }
    } catch (error) {
        loadingRef.value.close()
        showError('Failed');
        console.error("Upload failed:", error);
    }
};


const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const showSuccess = (message: string) => {
    toastContent.value = message;
    isSuccess.value = true;
    statusRef.value.open()
}
const updateProfile = (imageData: any) => {
    loadingRef.value.open()
    let data = {
        uid: id.value,
        change_item: "headimg",
        change_value: imageData.url
    }
    upadateProfileImage(data).then(res => {
        loadingRef.value.close()
        showSuccess(t(res.msg))
        userStore.getInfo();
    }).catch(err => {
        loadingRef.value.close()
        showError(err);
    })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(themeStore).themeIndex === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(AvatarViewOne, {
            "data-set": dataSet.value,
            onAfterRead: afterRead
          }, null, 8, ["data-set"])
        ]))
      : _createCommentVNode("", true),
    (_unref(themeStore).themeIndex === 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(AvatarViewTwo, {
            "data-set": dataSet.value,
            onAfterRead: afterRead
          }, null, 8, ["data-set"])
        ]))
      : _createCommentVNode("", true),
    (_unref(themeStore).themeIndex === 3)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(AvatarViewThree, {
            "data-set": dataSet.value,
            onAfterRead: afterRead
          }, null, 8, ["data-set"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(StatusPopup, {
      ref_key: "statusRef",
      ref: statusRef,
      "is-show-success": isSuccess.value,
      content: toastContent.value
    }, null, 8, ["is-show-success", "content"]),
    _createVNode(LoadingScreen, {
      ref_key: "loadingRef",
      ref: loadingRef
    }, null, 512)
  ], 64))
}
}

})